export default __webpack_public_path__ + "static/media/40219.2736ef3f.jpg";